import React from 'react';

var Rating = React.createClass({
	render: function(){
		var data = this.props.data;
		var ratings = [];
    var ratingAvg  = data["rating_avg"];
    for(var i=1;i<=5;i++)
    {
      var decimal = Math.floor(ratingAvg);
      var fraction = ratingAvg % 1;
      var ratingClas;
      if(i<= decimal){
        ratingClas = "fa fa-star";  // for empty star.
      }
      else if(fraction >= 0.5 && i<= decimal+1){
        ratingClas = "fa fa-star-half-o";  // for half filled star.
      }
      else{
        ratingClas = "fa fa-star-o";  // for full filled star.
      }
      ratings.push(<i key = {i} className = {ratingClas}/>);
    }  
  	return(
  		<p><span>Rating:</span><span className="rating--star">{ratings}</span> <span>({data["rating_count"]})</span></p>
  	);
	}
});

export {Rating};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/Rating.jsx
 **/